export const PATIENT_REDIRECT_WHITELIST = [
  '/',
  '/account',
  '/account/*',
  '/about',
  '/questionnaire/*',
  '/self-referral/init/*',
  '/mfa-setup',
];
